import React from 'react';
import { Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import styles from './queryFailedPopover.module.scss';

interface QueryFailedPopoverProps {
  onBack: () => void;
}

const QueryFailedPopover: React.FC<QueryFailedPopoverProps> = ({ onBack }) => (
  <div className={styles.container}>
    <WarningOutlined className={styles.icon} />
    <span className={styles.message}>Query did not succeed. Please try again.</span>
    <Button className={styles.backButton} onClick={onBack}>
      Back
    </Button>
  </div>
);

export default QueryFailedPopover;
